import { useDeviceType } from '../../../../responsive';
export var useColProps = function useColProps(props) {
  var _ref, _ref2, _ref3;
  var xs = props.xs,
    m = props.m,
    l = props.l,
    xsOffset = props.xsOffset,
    mOffset = props.mOffset,
    lOffset = props.lOffset,
    xsOffsetRight = props.xsOffsetRight,
    mOffsetRight = props.mOffsetRight,
    lOffsetRight = props.lOffsetRight,
    xsHidden = props.xsHidden,
    mHidden = props.mHidden,
    lHidden = props.lHidden;
  var device = useDeviceType();
  var cols = {
    desktop: (_ref = l !== null && l !== void 0 ? l : m) !== null && _ref !== void 0 ? _ref : xs,
    tablet: m !== null && m !== void 0 ? m : xs,
    phone: xs
  };
  var offsets = {
    desktop: (_ref2 = lOffset !== null && lOffset !== void 0 ? lOffset : mOffset) !== null && _ref2 !== void 0 ? _ref2 : xsOffset,
    tablet: mOffset !== null && mOffset !== void 0 ? mOffset : xsOffset,
    phone: xsOffset
  };
  var offsetsRight = {
    desktop: (_ref3 = lOffsetRight !== null && lOffsetRight !== void 0 ? lOffsetRight : mOffsetRight) !== null && _ref3 !== void 0 ? _ref3 : xsOffsetRight,
    tablet: mOffsetRight !== null && mOffsetRight !== void 0 ? mOffsetRight : xsOffsetRight,
    phone: xsOffsetRight
  };
  var hiddens = {
    desktop: lHidden,
    tablet: mHidden,
    phone: xsHidden
  };
  return {
    col: cols[device],
    offset: offsets[device],
    offsetRight: offsetsRight[device],
    hidden: hiddens[device]
  };
};